import axios from 'axios';
import API from '../config/API';

/**
 * Self-employed stylists' choices, read in one call (GET /team/se-choices).
 * Reads only: every choice is still written through its own endpoint, which
 * only the stylist can use.
 *
 *   team()  every SE at this location (owner, or a role with `team`)
 *   mine()  the signed-in SE's own, plus their diary list and marketing row id
 *
 * Both resolve to the responseData ({ salon, stylists } / { salon, me }) and
 * reject with the server's reason.
 */

const headers = () => ({
  'Content-Type': 'application/json',
  authorization: 'Basic YmV1YXBwOmJldWFwcA==',
  accessToken: `${localStorage.getItem('accessToken')}`,
});

const unwrap = (res) => {
  const d = res && res.data;
  if (d && d.statusCode === 1 && d.responseData) return d.responseData;
  const reason = (d && d.error && (d.error.responseMessage || d.error.message)) || 'I couldn’t load these choices just now.';
  const e = new Error(reason);
  e.plain = true;
  throw e;
};

export const seChoicesService = {
  team: () => axios.get(API.TEAM_SE_CHOICES, { headers: headers() }).then(unwrap),
  mine: () => axios.get(API.TEAM_SE_CHOICES_ME, { headers: headers() }).then(unwrap),
};

export default seChoicesService;
